import { createSlice } from "@reduxjs/toolkit";
import { VISITTYPE } from "@/src/lib/util/config";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

export const billingSteps = {
    CONFIRM_PATIENT: 0,
    SELECT_DATE_TIME: 1,
    UPLOAD_DOCUMENTS: 2,
    ORDER_CONFIRMATION: 3,
};

const initialState = {
    homeCheckoutLines: { discountAmount: 0 },
    centreCheckoutLines: { discountAmount: 0 },
    currentStep: billingSteps.CONFIRM_PATIENT,
    visitType: VISITTYPE.HOME,
    cartCount: 0, // Added to track cart count
};

const cartSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        updateVisitType: (state, action) => {
            state.visitType = action.payload;
        },
        updateCurrentStep: (state, action) => {
            state.currentStep = action.payload;
        },
        updateHomeCheckoutLines: (state, action) => {
            state.homeCheckoutLines = {
                ...state.homeCheckoutLines,
                ...action.payload,
            };
        },
        updateResponse: (state, action) => {
            state.response = action.payload;
        },
        updateCentreCheckoutLines: (state, action) => {
            state.centreCheckoutLines = {
                ...state.centreCheckoutLines,
                ...action.payload,
            };
        },
        updateCartCount: (state, action) => {
            state.cartCount = action.payload; // Added reducer to update cart count
        },
        clearCart: () => initialState, // Reset state to initialState here,
    },
});

// Action creators are generated for each case reducer function
export const {
    updateVisitType,
    updateCurrentStep,
    updateHomeCheckoutLines,
    updateCentreCheckoutLines,
    clearCart,
    updateResponse,
    updateCartCount, // Exported new cartCount reducer
} = cartSlice.actions;

export const selectCurrentStep = (state) => state.cart.currentStep;
export const selectVisitType = (state) => state.cart.visitType;

const persistConfig = {
    key: "cart",
    storage,
    whitelist: ["cartCount"], // Persist only the cartCount field
};

const persistedCartReducer = persistReducer(persistConfig, cartSlice.reducer);

export const cartReducer = persistedCartReducer;
